import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {isStaff} from '@github-ui/stats'
import {useCallback} from 'react'

import {ViewTypeParam} from '../../api/view/contracts'
import {ViewStateActionTypes} from '../../hooks/use-view-state-reducer/view-state-action-types'
import {useViews} from '../../hooks/use-views'

type UseAgentAssignmentVisibility = {
  /** Whether or not the table should show agent assignment tasks */
  agentAssignmentVisible: boolean
  /** Set the agent assignment visibility state */
  setAgentAssignmentVisible: (viewNumber: number, visible: boolean) => void
}

export const useAgentAssignmentVisibility = (): UseAgentAssignmentVisibility => {
  /* eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags --
     TODO: Migrate to isFeatureEnabled from @github-ui/feature-flags. See
     https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
  const projectsCopilotTasksStatus = useFeatureFlag('projects_copilot_tasks_status')
  const {currentView, viewStateDispatch} = useViews()

  const visible =
    projectsCopilotTasksStatus &&
    currentView?.localViewState?.layout === ViewTypeParam.Table &&
    (currentView?.localViewState?.layoutSettings?.table?.agentAssignment?.visible ?? isStaff())

  const setVisible = useCallback(
    (viewNumber: number, newVisible: boolean): void => {
      if (!projectsCopilotTasksStatus) return
      viewStateDispatch({
        type: ViewStateActionTypes.SetAgentAssignmentVisible,
        viewNumber,
        visible: newVisible,
      })
    },
    [projectsCopilotTasksStatus, viewStateDispatch],
  )

  return {
    agentAssignmentVisible: visible,
    setAgentAssignmentVisible: setVisible,
  }
}
